import { createReducer, on } from '@ngrx/store';
import * as fromLandingModal from '../actions/landing.modal.action';
import { StateSlice } from '@core/helpers/state-slice';

export type LandingModalState = StateSlice<boolean>;

export const initialState: LandingModalState = {
  data: false,
  loaded: false,
  loading: false,
  error: null,
};

const landingModalReducer = createReducer(
  initialState,
  on(fromLandingModal.viewedLandingModal, (state) => {
    return {
      ...state,
      data: true,
      loading: false,
      loaded: true,
    };
  })
);

export function reducer(
  state: LandingModalState | undefined,
  action: fromLandingModal.LandingModalActions
) {
  return landingModalReducer(state, action);
}
